<template>
  <div class="iv-block">
    <header class="iv-block-title">
      <Iconfont :type="type" v-if="type" :style="{fontSize: size + 'px'}"></Iconfont>
      <p class="iv-block-title-strip" v-else></p>
      <span class="iv-fs-16 iv-fc-85 iv-fw-b" :class="`iv-m-l-${type ? 32 : 20}`">{{title}}</span>
      <span v-if="noMore" class="iv-block-title-right iv-fs-14 iv-fc-25 iv-pointer" @click="toMorePage">{{moreText}}</span>
    </header>
    <slot></slot>
  </div>
</template>

<script>
import Iconfont from '@/components/iconfont'

export default {
  props: {
    //判断更多显示不显示
    noMore: {
      type: Boolean,
      default: true
    },
    type: { //icon图标
      type: String,
      default: ''
    },
    size: { //icon大小  font-size  因为图标大小是不标准的
      type: String,
      default: '28'
    },
    title: {
      type: String,
      default: '自主功能入口'
    },
    moreText: {
      type: String,
      default: '更多 >'
    }
  },
  methods: {
    toMorePage () {
      this.$emit('on-more')
    }
  },
  components: {
    Iconfont
  }
}
</script>

<style lang="scss" scoped>
.iv-block {
  padding: 0 20px;
  background: #fff;
  border-radius: 16px;
  .iv-block-title {
    padding: 16px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    position: relative;
    .iconfont {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
    }
    .iv-block-title-strip {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      width: 6px;
      height: 20px;
      background: #009AD8;
      border-radius: 3px;
    }
    .iv-block-title-right {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }
  }
}
</style>
